import {
  NodeViewWrapper,
  NodeViewProps,
  ReactNodeViewRenderer,
} from '@tiptap/react'
import { UpdatedImage } from '@basehub/tiptap-api-utils'
import { UploadImagesPlugin } from '~/lib/tiptap/plugins/upload-image'
import ReactTextareaAutosize from 'react-textarea-autosize'

export const CustomImage = UpdatedImage.extend({
  addProseMirrorPlugins() {
    return [UploadImagesPlugin()]
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView, {
      className: 'rt-image',
    })
  },
  addKeyboardShortcuts() {
    return {
      // if key down on the image block, focus the input
      ArrowDown: ({ editor }) => {
        const selectedNode = editor.view.dom.querySelector(
          '.ProseMirror-selectednode'
        )
        if (selectedNode && selectedNode.classList.contains('rt-image')) {
          // select input
          const input = selectedNode.querySelector('textarea')
          input?.focus()
          return true
        }
        return false
      },
    }
  },
}).configure({
  allowBase64: true,
})

const ImageNodeView = ({
  updateAttributes,
  node,
  editor,
  getPos,
}: NodeViewProps) => {
  return (
    <NodeViewWrapper as="figure">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        data-drag-handle
        draggable={true}
        style={{
          aspectRatio:
            node.attrs.width && node.attrs.height
              ? `${node.attrs.width} / ${node.attrs.height}`
              : undefined,
        }}
        src={node.attrs.src}
        alt={node.attrs.caption}
        aspect-ratio={
          node.attrs.width && node.attrs.height
            ? `${node.attrs.width} / ${node.attrs.height}`
            : undefined
        }
      />
      {editor.isEditable ? (
        <ReactTextareaAutosize
          minLength={1}
          placeholder="Caption..."
          value={node.attrs.caption ?? ''}
          onChange={(e) => {
            updateAttributes({
              caption: e.target.value,
            })
          }}
          onKeyDown={(e) => {
            e.stopPropagation()
            if (e.key === 'Escape' || e.key === 'Tab') {
              e.preventDefault()
              editor.commands.focus(getPos() + node.nodeSize)
              return
            } else if (e.key === 'ArrowDown' || e.key === 'Enter') {
              // Move to the next block
              e.preventDefault()
              const pos = getPos()
              editor.commands.focus(pos + node.nodeSize + 1)
              return
            } else if (e.key === 'ArrowUp') {
              // Move to the previous block
              e.preventDefault()
              const pos = getPos()
              editor.commands.focus(pos - 1)
              return
            }
            // cmd + z
            else if (e.key === 'z' && e.metaKey) {
              e.stopPropagation()
              return
            }
          }}
          className="w-full text-center pt-1 text-xs h-auto min-h-[12px] outline-none text-dark-muted resize-none placeholder:text-dark-faint"
        />
      ) : (
        <figcaption>{node.attrs.caption}</figcaption>
      )}
    </NodeViewWrapper>
  )
}
